// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TTbL","questions":"styles_questions__1lG36","footer":"styles_footer__1ozMC"};